import { forwardRef, type ButtonHTMLAttributes, type AnchorHTMLAttributes, type ElementType, type ReactNode } from 'react';
import classnames from 'src/util/classnames';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  color?: string;
  size?: 'xs' | 'sm' | 'lg';
  outline?: boolean;
  block?: boolean;
  active?: boolean;
  close?: boolean;
  tag?: ElementType;
  innerRef?: React.Ref<HTMLElement>;
  href?: string;
  children?: ReactNode;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { color = 'secondary', size = 'sm', outline, block, active, close, disabled, tag, innerRef, className, children, ...props },
  ref,
) {
  if (close) {
    return (
      <button type="button" className={classnames('btn-close', className)} aria-label="Close" ref={ref ?? innerRef as any} {...props} />
    );
  }

  const Tag = (tag ?? 'button') as ElementType;
  return (
    <Tag
      type={Tag === 'button' ? 'button' : undefined}
      className={classnames(
        'btn',
        outline ? `btn-outline-${color}` : `btn-${color}`,
        size && `btn-${size}`,
        block && 'w-full block',
        active && 'active',
        disabled && 'disabled',
        className,
      )}
      disabled={Tag === 'button' ? disabled : undefined}
      ref={ref ?? innerRef}
      {...props}
    >
      {children}
    </Tag>
  );
});
